// ADDED
import { useState, useEffect } from "react";
import { payrollPeriodService } from "../services/payrollPeriodService";

export const usePayrollPeriods = (year) => {
  const [periods, setPeriods] = useState([]);
  const [loadingPeriods, setLoadingPeriods] = useState(false);

  useEffect(() => {
    if (!year) return;

    const fetchPayrollPeriodsByYear = async () => {
      setLoadingPeriods(true);
      try {
        const res = await payrollPeriodService.getPeriodsByYear(year);
        // Only show Active periods as per requirements
        const activePeriods = (res.data || []).filter(p => p.isActive);

        const formatted = activePeriods.map(p => ({
          value: p.id,
          label: `${p.name} ${p.identifier ? `(${p.identifier})` : ""}`
        }));

        setPeriods(formatted);
      } catch (err) {
        console.error("Failed to fetch payroll periods", err);
      } finally {
        setLoadingPeriods(false);
      }
    };

    fetchPayrollPeriodsByYear();
  }, [year]);

  return { periods, loadingPeriods };
};